<template>
  <span :class="{'jo-formula':true,'no-click':layout != 'rc'}" v-if="this.data.math" v-html="this.data.math"></span>
  <span :class="{'jo-formula':true,'no-click':layout != 'rc'}" v-else-if="this.data.latex">{{data.latex}}</span>
  <span v-else-if="this.data.graphicsData && this.data.graphicsData.small">
    <img class="math" v-if="layout != 'rc'" v-lazy="this.data.graphicsData.small" alt="math"
         @click="showBigPic()" :data-width="width"/>
    <img class="math" v-else :src="this.data.graphicsData.small" alt="math" :style="{'width' : width + 'px'}"/>
    <el-dialog v-if="this.data.graphicsData.big && showBig" width="inherit" top="0"
               custom-class="jo-bigPicDialog" :visible.sync="isShowBigPic">
      <img :src="this.data.graphicsData.big" alt="math">
    </el-dialog>
  </span>
</template>

<script>
  export default {
    props: [
      'data',
      'showBig'
    ],
    data () {
      return {
        width: null,
        isShowBigPic : false
      }
    },
    mounted () {
      if(this.data.math || this.data.latex){
        if (typeof MathJax !== 'undefined'){
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);}
      }else if(this.data.graphicsData == null ){
        return
      }else if(this.data.graphicsData.width != null){
        this.width = this.data.graphicsData.width * this.GLOBAL.deviceDPI.x / 25.4*1.2
      }
    },
    methods: {
      showBigPic() {
        if (this.layout !== 'rc'){
          this.isShowBigPic = true;
        }
      }
    }
  }
</script>

<style lang="scss">
img.math{
  vertical-align: middle;
}
  .no-click{
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/formula/math.vue